/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { StringLib, StringLibInterface } from "../StringLib";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes1",
        name: "b",
        type: "bytes1",
      },
    ],
    name: "char",
    outputs: [
      {
        internalType: "bytes1",
        name: "c",
        type: "bytes1",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "x",
        type: "address",
      },
    ],
    name: "toAsciiString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "toString",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class StringLib__factory {
  static readonly abi = _abi;
  static createInterface(): StringLibInterface {
    return new Interface(_abi) as StringLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): StringLib {
    return new Contract(address, _abi, runner) as unknown as StringLib;
  }
}
